module.exports = __webpack_public_path__ + "static/gpx1-3b6894e1ebf5a582b33052d1f952e377.png";